module.exports = __webpack_public_path__ + "static/media/en-ca-insolv-kingbond-ReceivershipAppointmentOrder-May22025.9eb4b056.pdf";